var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "s-pagination"
  }, [_c('li', {
    attrs: {
      "disabled": _vm.current <= 1
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.withPage(_vm.current - 1)
    }
  }, [_vm._v("<")])], 1), _vm._l(_vm.last, function (i) {
    return _c('li', {
      key: i,
      class: {
        active: i === _vm.current
      }
    }, [_c('router-link', {
      attrs: {
        "to": _vm.withPage(i)
      }
    }, [_vm._v(_vm._s(i))])], 1);
  }), _c('li', {
    attrs: {
      "disabled": _vm.current >= _vm.last
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.withPage(_vm.current + 1)
    }
  }, [_vm._v(">")])], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }